













































































































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { notify } from '@/web/utils/notify';
import { saveAs } from '@/web/utils/save-file';
import { formatDate } from '@/web/utils/format';
import { mapGetters } from 'vuex';
import PaymentPlanInvoicesModal from '@/web/components/payment-plans/PaymentPlanInvoicesModal.vue';
import { errorToMessage } from '@/core/utils/errors';

interface LocalState {
  search: string;
  date: DatePicker;
  tableFields: PaginatedTableField[];
}

export default Vue.extend({
  name: 'PaymentPlans',
  components: {
    TopNav,
    NavItem,
  },
  data(): LocalState {
    return {
      search: '',
      status: '',
      selectedProduct: null,
      selectedStudent: null,
      date: {},
      tableFields: [
        {
          title: this.$t('PAYMENT_PLANS.TABLE.NAME') as string,
          name: 'full_name',
          cssClass: 'h5 m-0',
          ordering: 'student__first_name',
        },
        {
          title: this.$t('PAYMENT_PLANS.TABLE.EMAIL') as string,
          key: 'student.email',
          cssClass: 'h5 m-0',
          ordering: 'student__email',
        },
        {
          title: this.$t('PAYMENT_PLANS.TABLE.PRODUCT') as string,
          key: 'product.product_name',
          cssClass: 'h5 m-0',
          ordering: 'product__product_name',
        },
        {
          name: 'created',
          title: this.$t('PAYMENT_PLANS.TABLE.PURCHASE_DATE') as string,
          ordering: 'created',
        },
        {
          name: 'status',
          title: this.$t('PAYMENT_PLANS.TABLE.STATUS') as string,
          cssClass: 'h5 m-0',
        },
        {
          name: 'paid_invoices',
          title: this.$t('PAYMENT_PLANS.TABLE.PAID_INVOICES') as string,
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      paymentPlanStats: 'sale/paymentPlanStats',
    }),
    query(): {} {
      return {
        q: this.search,
        status: this.status,
        product: this.selectedProduct?.id,
        student: this.selectedStudent?.id,
        startDate: this.date?.startDate,
        endDate: this.date?.endDate,
      };
    },
    showEmpty(): boolean {
      const ordersTable = this.$store.state['orders-table'];
      if (ordersTable) {
        return ordersTable.perPage === 0 && !ordersTable.isLoading;
      }
      return false;
    },
  },
  methods: {
    selectPaymentPlan(data) {
      this.$modal.show(PaymentPlanInvoicesModal, {
        paymentPlan: data,
        refreshFn: () => {
          this.$refs.paymentPlansTable.refresh();
        },
      });
    },
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    formatStatus(status: string): string {
      return this.$t(`PAYMENT_PLANS.STATUS.${status.toUpperCase()}`);
    },
    getStatusToolTip(cancelReason: string): string {
      if (!cancelReason) return null;

      return this.$t(
        `PAYMENT_PLANS.TEXT.CANCEL_REASON_${cancelReason.toUpperCase()}`
      );
    },
    async exportAll(): Promise<void> {
      const table = this.$refs.paymentPlansTable as any;
      const data = await this.$store.dispatch('sale/exportPaymentPlans', {
        ...this.query,
        ordering: `${table.orderingDirection}${table.ordering}`,
      });
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'payment-plans-export.csv');
    },
    async viewCustomer(order: SalesPurchaseResponse): Promise<void> {
      this.$router.push(`/customers/${order.customer.id}`);
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('sale/getPaymentPlanStats');
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load payment plan statistics',
        text: errorToMessage(error?.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
});
